import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MatSpinnerOverlayService {
  constructor() {}

  private subject = new Subject<boolean>();

  display(): void {
    this.subject.next(true);
  }

  hide(): void {
    this.subject.next(false);
  }

  getDisplay(): Observable<boolean> {
    return this.subject.asObservable();
  }
}
